export default function Reviews() {
  const reviews = [
    {
      name: 'Jennifer Painter',
      role: 'Local Guide · 46 reviews',
      avatar: 'JP',
      rating: 5,
      text: 'He did a great job! He was very thorough and took the time to explain everything that needed to be fixed and what was wrong. By the time he left, I was completely satisfied — my heat, which hasn\'t worked for months, is finally working again! I really appreciate the excellent service.',
      date: 'a month ago'
    },
    {
      name: 'Michael Rodriguez',
      role: 'Verified Customer',
      avatar: 'MR',
      rating: 5,
      text: 'Outstanding service! They came out the same day I called and fixed my AC unit quickly. The technician was professional, knowledgeable, and explained everything clearly. Highly recommend Trio HVACR!',
      date: '2 weeks ago'
    },
    {
      name: 'Sarah Thompson',
      role: 'Homeowner',
      avatar: 'ST',
      rating: 5,
      text: 'Best HVAC company in Baltimore! They installed a new heating system in my home and the work was impeccable. Fair pricing, excellent communication, and top-notch service.',
      date: '3 weeks ago'
    },
    {
      name: 'David Chen',
      role: 'Business Owner',
      avatar: 'DC',
      rating: 5,
      text: 'We use Trio for all our commercial HVAC needs. They are reliable, professional, and always deliver quality work. Their maintenance plans have saved us money in the long run.',
      date: '1 month ago'
    },
    {
      name: 'Lisa Martinez',
      role: 'Verified Customer',
      avatar: 'LM',
      rating: 5,
      text: 'Called them for an emergency repair on a Sunday and they came right away. Fixed the problem efficiently and at a fair price. True professionals who care about their customers!',
      date: '2 months ago'
    },
    {
      name: 'Robert Johnson',
      role: 'Homeowner',
      avatar: 'RJ',
      rating: 5,
      text: 'Excellent experience from start to finish. The team was punctual, respectful of my home, and did an amazing job installing our new AC system. Couldn\'t be happier!',
      date: '3 months ago'
    }
  ];

  return (
    <section id="reviews" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <div className="inline-block bg-white px-5 py-2 rounded-full mb-6 shadow-sm">
            <span className="text-xs font-medium text-gray-700 uppercase tracking-wide">Customer Reviews</span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-gray-900 leading-tight">
            What Our Customers<br />
            <span className="font-light text-gray-600">Are Saying</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {reviews.map((review, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 shadow-sm hover:shadow-lg transition-all duration-300"
            >
              <div className="flex items-start space-x-4 mb-6">
                <div className="w-14 h-14 rounded-full bg-orange-600 flex items-center justify-center text-white font-bold text-base flex-shrink-0">
                  {review.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <h4 className="text-base font-bold text-gray-900">{review.name}</h4>
                  <p className="text-sm text-gray-500">{review.role}</p>
                  <div className="flex items-center mt-1">
                    {[...Array(review.rating)].map((_, i) => (
                      <i key={i} className="ri-star-fill text-yellow-400 text-sm"></i>
                    ))}
                    <span className="text-xs text-gray-400 ml-2">{review.date}</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed">
                &ldquo;{review.text}&rdquo;
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <a
            href="https://www.google.com/search?q=trio+hvacr+services+baltimore"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center space-x-2 text-gray-900 font-medium hover:text-orange-600 transition-colors cursor-pointer"
          >
            <span>Read More Reviews on Google</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
